import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import selectors from '@/ui/flux/selectors';

function useAsset(assetName: string): Asset | undefined {
  return useSelector(selectors.assets.createAssetSelector(assetName));
}

export default useAsset;
